import React from "react";

import { Box, Icon, MenuItem } from "@chakra-ui/react";

import AddIcon from "@/assets/svg/add-list-icon.svg";

import ListText from "../shared/ListText";


const AddViewItem = ({ handler, isView, isTagMenu = true }) => {
  const tagName = isTagMenu ? MenuItem : Box;
  return (
    <Box
      as={tagName}
      py={"0"}
      display={"flex"}
      alignItems={"center"}
      columnGap={"12px"}
      h={"44px"}
      px={"22px"}
      _focusWithin={{ bg: "none" }}
      _hover={{ bg: isView ? "lightBlue2" : "lightGreen2" }}
      cursor={"pointer"}
      onClick={(event) => {
        event.stopPropagation();
        handler();
      }}
    >
      <Icon as={AddIcon} w={"28px"} h={"28px"} />
      <ListText title={`Add ${isView ? "view" : "list"}`} />
    </Box>
  );
};

export default AddViewItem;
